export { Footer } from "./Footer";
export type { FooterProps } from "./Footer";
export * from "./Footer";

export const COPYRIGHT_TEXT = "No reproduction without permission.";
